function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_575",
  "data-name": "Rectangle 575",
  width: 190,
  height: 110,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  y1: 1,
  x2: 0.5,
  y2: -0.001,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.102
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_48",
  "data-name": "Group 48",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "undraw_programming_2svr",
  transform: "translate(0 4.415)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_511",
  "data-name": "Path 511",
  d: "M197.2,131.088q-.491,1.034-.97,2.028c-.142.294-.284.582-.422.87-1.565,3.2-3.026,6.038-4.267,8.369a13.319,13.319,0,0,1-11.612,7.058l-27.6.3h-.291l-2.366.026-2.024.022-6.205.068h-.251l-3.159.035h-.1l-19.472.212-17.381.182-2.022.022-12.556.137H86.49l-8.144.088h-.087l-25.75.279-7.7.084a15.993,15.993,0,0,1-4.853-.7,15.717,15.717,0,0,1-7.114-4.514,36.482,36.482,0,0,1-7.339-12.54q-.351-1-.655-2.028c-5.607-18.994,1.228-43.5,13.53-59.9q.773-1.029,1.572-2.006l.013-.015A50.455,50.455,0,0,1,52.5,57.861c8.007-4.908,16.878-6.29,25.6-2.17a57.177,57.177,0,0,0,20.958,5.572c.675.044,1.35.077,2.022.1,15.328.483,29.693-5.052,46.563-8.624.671-.142,1.345-.283,2.024-.416a110.661,110.661,0,0,1,41.26-1,34.348,34.348,0,0,1,4.87,1.167q1.05.339,2.024.729c7.578,3.089,11.71,8.8,13.466,15.95q.249,1,.431,2.026C214.839,88.393,197.406,130.644,197.2,131.088Z",
  transform: "translate(-22.862 -49.827)",
  fill: "#e30613",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_46",
  "data-name": "Group 46",
  transform: "translate(1.983 2.481)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_512",
  "data-name": "Path 512",
  d: "M62.468,62.519v92.959l-7.7.084a15.991,15.991,0,0,1-4.853-.7V73.829h.013A50.245,50.245,0,0,1,62.468,62.519Z",
  transform: "translate(-34.809 -56.984)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_513",
  "data-name": "Path 513",
  d: "M220.782,82.4H47.423q.773-1.026,1.572-2v-.015H220.351Q220.6,81.37,220.782,82.4Z",
  transform: "translate(-33.892 -63.564)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_514",
  "data-name": "Path 514",
  d: "M298.688,54.747v77.7h-.631q-.491,1.032-.97,2.024c-.142.293-.284.581-.422.868V54.012Q297.715,54.35,298.688,54.747Z",
  transform: "translate(-125.706 -53.85)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_515",
  "data-name": "Path 515",
  d: "M222.452,53.755V151.2l-2.024.022V54.171C221.1,54.029,221.773,53.888,222.452,53.755Z",
  transform: "translate(-97.622 -53.755)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_516",
  "data-name": "Path 516",
  d: "M145.531,67.981v88.948l-2.022.022V67.884C144.185,67.928,144.86,67.953,145.531,67.981Z",
  transform: "translate(-69.288 -58.96)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_517",
  "data-name": "Path 517",
  d: "M198.353,178.2q-.491,1.032-.97,2.024H26.657q-.351-1-.655-2.024Z",
  transform: "translate(-26.002 -99.418)",
  fill: "#e30613"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_566",
  "data-name": "Rectangle 566",
  width: 3.458,
  height: 10.493,
  transform: "translate(38.505 48.486)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_567",
  "data-name": "Rectangle 567",
  width: 3.458,
  height: 11.101,
  transform: "translate(131.555 47.94)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_518",
  "data-name": "Path 518",
  d: "M168.325,150.724v2.366l-27.646.255-.295.005-10.507.1-.251,0-3.194.027h-.095l-19.468.18-31.957.3h-.027l-8.125.076-.087,0-36.1.331v-2.73l8.489-5.1,17.033-.142.364,0,.12,0,.364-.005,8.178-.067.366,0,.116,0,.364,0,2.622-.022.069,0,6.469-.055h.053l50.481-.426,1.236-.009h.124l.943-.009,6.851-.056.364-.005.337,0h.175l2.131-.016.422-.005.566,0,1.774-.016,2.815-.024.364,0,.633,0h.118l13.6-.116Z",
  transform: "translate(-11.262 -53.398)",
  fill: "#65617d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_519",
  "data-name": "Path 519",
  d: "M168.325,150.724v2.366l-27.646.255-.295.005-10.507.1-.251,0-3.194.027h-.095l-19.468.18-31.957.3h-.027l-8.125.076-.087,0-36.1.331v-2.73l8.489-5.1,17.033-.142.364,0,.12,0,.364-.005,8.178-.067.366,0,.116,0,.364,0,2.622-.022.069,0,6.469-.055h.053l50.481-.426,1.236-.009h.124l.943-.009,6.851-.056.364-.005.337,0h.175l2.131-.016.422-.005.566,0,1.774-.016,2.815-.024.364,0,.633,0h.118l13.6-.116Z",
  transform: "translate(-11.262 -53.398)",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_520",
  "data-name": "Path 520",
  d: "M103.161,189.163v4.457a1.115,1.115,0,0,1-.637,1.008,1.092,1.092,0,0,1-.455.109l-6.351.135a1.092,1.092,0,0,1-.491-.1,1.114,1.114,0,0,1-.65-1.014v-4.591Z",
  transform: "translate(-49.279 -100.934)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_521",
  "data-name": "Path 521",
  d: "M103.161,189.163v4.457a1.115,1.115,0,0,1-.637,1.008,1.092,1.092,0,0,1-.455.109l-6.351.135a1.092,1.092,0,0,1-.491-.1,1.114,1.114,0,0,1-.65-1.014v-4.591Z",
  transform: "translate(-49.279 -100.934)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_522",
  "data-name": "Path 522",
  d: "M103.737,189.163v4.457a1.116,1.116,0,0,1-.637,1.008,1.092,1.092,0,0,1-.455.109l-6.351.135a1.092,1.092,0,0,1-.491-.1,1.114,1.114,0,0,1-.65-1.014v-4.591Z",
  transform: "translate(-49.492 -100.934)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_568",
  "data-name": "Rectangle 568",
  width: 8.584,
  height: 5.732,
  transform: "translate(123.912 88.229)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_569",
  "data-name": "Rectangle 569",
  width: 8.584,
  height: 5.732,
  transform: "translate(123.912 88.229)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_570",
  "data-name": "Rectangle 570",
  width: 8.584,
  height: 5.732,
  transform: "translate(123.548 88.229)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_523",
  "data-name": "Path 523",
  d: "M64.421,76.585v1.043l-3.458-.089v-.954Z",
  transform: "translate(-22.459 -28.111)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_524",
  "data-name": "Path 524",
  d: "M102.226,78.058,98.071,107.9a.782.782,0,0,1-.8.675l-33.266-.863-.631-.016a.783.783,0,0,1-.757-.886L67.286,75.57a.783.783,0,0,1,.826-.661L101.5,77.17a.781.781,0,0,1,.728.888Z",
  transform: "translate(-37.506 -59.014)",
  fill: "#65617d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_525",
  "data-name": "Path 525",
  d: "M48.635,28.569,45.118,56.107l30.572.97,3.76-26.569Z",
  transform: "translate(-16.622 -10.475)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_571",
  "data-name": "Rectangle 571",
  width: 37.245,
  height: 31.542,
  rx: 1.536,
  transform: "translate(69.987 17.669)",
  fill: "#65617d"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_572",
  "data-name": "Rectangle 572",
  width: 33.848,
  height: 26.265,
  transform: "translate(71.745 19.795)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_526",
  "data-name": "Path 526",
  d: "M211.739,75.72v.69l-3.458.071V75.72Z",
  transform: "translate(-76.727 -27.794)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_527",
  "data-name": "Path 527",
  d: "M239.087,105.975a.561.561,0,0,1-.546.6l-34.066.7a.56.56,0,0,1-.57-.508l-2.928-30.441a.56.56,0,0,1,.531-.613l33.808-1.681.364-.018a.559.559,0,0,1,.586.51Z",
  transform: "translate(-88.473 -58.687)",
  fill: "#65617d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_528",
  "data-name": "Path 528",
  d: "M181.2,28.836l30.876-1.518,2.608,27.661-30.632.728Z",
  transform: "translate(-66.75 -10.017)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_529",
  "data-name": "Path 529",
  d: "M259.115,105.975a.56.56,0,0,1-.546.6l-3.225-32.539.364-.018a.559.559,0,0,1,.586.51Z",
  transform: "translate(-108.501 -58.687)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_530",
  "data-name": "Path 530",
  d: "M68.118,74.907,64.01,107.714l-.631-.016a.783.783,0,0,1-.757-.886l4.664-31.242A.783.783,0,0,1,68.118,74.907Z",
  transform: "translate(-37.506 -59.014)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_573",
  "data-name": "Rectangle 573",
  width: 3.458,
  height: 3.108,
  transform: "translate(38.505 55.879)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_531",
  "data-name": "Path 531",
  d: "M80.879,139.343v.9l-8.584.229v-1.134Z",
  transform: "translate(-26.633 -51.116)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_532",
  "data-name": "Path 532",
  d: "M111.555,139.391V170a.728.728,0,0,1-.7.719l-34.876.928H75.97a.728.728,0,0,1-.719-.719V139.391a.728.728,0,0,1,.719-.719h34.867A.728.728,0,0,1,111.555,139.391Z",
  transform: "translate(-42.16 -82.335)",
  fill: "#65617d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_533",
  "data-name": "Path 533",
  d: "M75.979,138.672v32.974H75.97a.728.728,0,0,1-.719-.719V139.391a.728.728,0,0,1,.719-.719Z",
  transform: "translate(-42.16 -82.335)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_534",
  "data-name": "Path 534",
  d: "M56.066,91.95h32.3v26.978l-32.3.728Z",
  transform: "translate(-20.655 -33.658)",
  fill: "#d4dfec"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_574",
  "data-name": "Rectangle 574",
  width: 3.458,
  height: 3.17,
  transform: "translate(131.555 55.879)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_535",
  "data-name": "Path 535",
  d: "M204.189,139.343v1.166l-8.584-.229v-.937Z",
  transform: "translate(-72.057 -51.116)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_536",
  "data-name": "Path 536",
  d: "M228.811,139.391v31.537a.728.728,0,0,1-.728.719h0l-34.883-.928a.728.728,0,0,1-.7-.719V139.391a.728.728,0,0,1,.719-.719h34.867A.728.728,0,0,1,228.811,139.391Z",
  transform: "translate(-85.351 -82.335)",
  fill: "#65617d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_537",
  "data-name": "Path 537",
  d: "M249.564,139.391v31.537a.728.728,0,0,1-.728.719h0V138.672h0a.728.728,0,0,1,.728.719Z",
  transform: "translate(-106.103 -82.335)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_538",
  "data-name": "Path 538",
  d: "M204.618,91.95h-32.3v26.978l32.3.728Z",
  transform: "translate(-63.478 -33.658)",
  fill: "#d4dfec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_539",
  "data-name": "Path 539",
  d: "M169.9,139.391V170a.728.728,0,0,1-.7.719l-34.876.928h0a.728.728,0,0,1-.728-.719V139.391a.728.728,0,0,1,.719-.719h34.867A.728.728,0,0,1,169.9,139.391Z",
  transform: "translate(-63.651 -82.335)",
  fill: "#65617d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_540",
  "data-name": "Path 540",
  d: "M114.408,91.95h32.3v26.978l-32.3.728Z",
  transform: "translate(-42.146 -33.658)",
  fill: "#d4dfec"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_541",
  "data-name": "Path 541",
  d: "M168.325,153.749v2.366l-27.646.255-.295.005-10.507.1-.251,0-3.194.027h-.095l-19.468.18-31.957.3h-.027l-8.125.076-.087,0-36.1.331v-2.73l36.852-.242h.087l7.459-.051H75l51.514-.34h.053l.031,0h.086l.872-.005h.266l13.556-.091.8,0,.178,0Z",
  transform: "translate(-11.262 -56.423)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_72",
  "data-name": "Ellipse 72",
  cx: 9.341,
  cy: 9.341,
  r: 9.341,
  transform: "translate(79.328 40.287)",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_542",
  "data-name": "Path 542",
  d: "M110.558,168.882a.225.225,0,0,1,.018-.064c.182-.653.506-1.758.748-2.641.031-.109.06-.217.087-.318.268-1,.788-3.327,1.077-4.781.1-.511.182-.91.2-1.11a30.291,30.291,0,0,1,1.2-3.135c.435-1.063.91-2.224,1.257-3.2a11.169,11.169,0,0,0,.533-1.792.928.928,0,0,0,0-.388,2.674,2.674,0,0,1-.087-.637h0a7.52,7.52,0,0,1,.815-3.66c.637-.91,1.092-4.306,1.092-4.306s.943.136,1.092-.642a1.119,1.119,0,0,0,.018-.255,1.348,1.348,0,0,0-.016-.2c-.162-1.136,2.679-2.344,4.276-2.6a3.577,3.577,0,0,1,.546-.051,4.957,4.957,0,0,0,1.137-.262q.255-.078.546-.182c.67-.226,1.47-.524,2.32-.852,3.2-1.239,7.064-2.912,7.064-2.912.027-.129.058-.253.093-.375a5.043,5.043,0,0,1,2.975-3.445h0V130.7c0-.628-.027-1.274-.055-1.918,0-.126-.011-.251-.018-.377V128.2c0-.127-.013-.255-.02-.38l-.033-.025a2.985,2.985,0,0,1-.71-.764,2.778,2.778,0,0,1-.258-.546,16.681,16.681,0,0,1-.433-1.956L136,124.4a15.294,15.294,0,0,0-.728-1.925c-.4-.986-.712-2-1.019-3.03q-.28-.934-.566-1.871l-.288-.954c-.055-.182-.109-.364-.151-.546h0a2.414,2.414,0,0,1-.047-.255h0a1.82,1.82,0,0,1,.044-.839,5.842,5.842,0,0,1,.24-.546,1.434,1.434,0,0,0,.091-.251h0a.549.549,0,0,0,.015-.058,1.028,1.028,0,0,0,.02-.2,3.359,3.359,0,0,0-.095-.708.013.013,0,0,1,0-.009.463.463,0,0,0-.009-.049,4.638,4.638,0,0,1-.065-.546,5.177,5.177,0,0,1,.631-2.833l.035-.065a4.587,4.587,0,0,1,.335-.506h0a2.562,2.562,0,0,1,.182-.222.727.727,0,0,1-1.01-.262.694.694,0,0,1-.042-.082c-.009-.022-.016-.046-.024-.069a1.487,1.487,0,0,1,.386-1.283,3.364,3.364,0,0,1,1.045-.855h0a.7.7,0,0,1,.073-.038,3.116,3.116,0,0,1,.48-.193h0a2.737,2.737,0,0,1,.3-.08l-.675-.062-.273-.025a2.637,2.637,0,0,1,2.366-1.985h.2a2.136,2.136,0,0,1,.286.024.808.808,0,0,1-.482-.788,2.622,2.622,0,0,0,1.672.557h.069a5.458,5.458,0,0,1-.062-.6h0a6.038,6.038,0,0,1,0-.812,1.536,1.536,0,0,0,1.234.411l-.379-.528a1.727,1.727,0,0,0,1.194.373l.087-.009a1.275,1.275,0,0,0,.217-.042h.016c-.035-.044-.066-.089-.1-.136l-.011-.022a1.759,1.759,0,0,1-.182-.38,1.2,1.2,0,0,1-.044-.158h0a1.593,1.593,0,0,1,.082-.992c.588.491,1.232,1.163,2,.655s.8-1.439,2-1.345a1.856,1.856,0,0,1,1.53,1.114,1.228,1.228,0,0,1,1.4-.318,1.247,1.247,0,0,1,.706,1.254,2.515,2.515,0,0,1,1.52-.06.887.887,0,0,1,.517,1.212.264.264,0,0,1-.025.036c-.224.289-.719.448-.666.812l.076.055.237.171q1.392,1,2.711,2.111a2.195,2.195,0,0,1,.963,1.425,1.573,1.573,0,0,1-.044.431h0c-.029.142-.069.284-.1.426a3.551,3.551,0,0,0-.062,1.1h0c.013.107.029.213.049.32.278,1.407,1.4,2.568,1.514,4v.1a3.239,3.239,0,0,1-.013.46,9.825,9.825,0,0,1-.815,2.548c-.02.051-.04.1-.058.153a25.352,25.352,0,0,0-1.274,5.125,18.24,18.24,0,0,1-.364,1.836,4.864,4.864,0,0,1-.926,1.9,2.951,2.951,0,0,1-.611.546,3.4,3.4,0,0,1-.482.257v.011c.02.111.036.222.056.333.011.058.02.116.031.182h0a.025.025,0,0,0,0,.011c.153.861.328,1.7.511,2.5l.093.4a3.452,3.452,0,0,1,2.58,3.174,1.751,1.751,0,0,1,0,.26s3.458.091,4.822,1.092a3.7,3.7,0,0,0,.821.419,15.109,15.109,0,0,0,1.683.526c.293.076.6.151.91.224.546.126,1.125.247,1.683.364,1.49.3,2.893.546,3.6.728,1.7.429,5.581,4.153,5.581,4.153s.455,3.756.91,4.3a16.232,16.232,0,0,1,1.274,2.473l3.01,5.352,1.274,2.251h.819a1.392,1.392,0,0,1,.584.382c.217.193.457.433.668.651l.349.373.218.242a1.889,1.889,0,0,1,1.681,1.079,8.213,8.213,0,0,1,3.327.455,2.571,2.571,0,0,1,.364.2,1.58,1.58,0,0,1,.752,1.03,1.519,1.519,0,0,1,.033.262c0,.1,0,.207,0,.309a5.075,5.075,0,0,1-1.787,3.3l.058.1s-.027.066-.08.182c-.015.035-.033.073-.053.116h0c-.107.229-.278.573-.5.975a11.522,11.522,0,0,1-1.742,2.4l-.053.055-10.507.1-.031-.036-2.038-2.431-1.014-1.208-.031-.038-.029.289-.1.964-.237,2.331-.013.116v.031l-.027.269.02-.269h-.053l-19.472.182-31.959.353v.153h-.025v-.153l-8.143.087Z",
  transform: "translate(-55.166 -68.184)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_543",
  "data-name": "Path 543",
  d: "M168.414,146.8s-18.107,2.184-16.378,0c.626-.79.8-3.13.764-5.8-.011-.81-.04-1.649-.082-2.484-.2-4-.682-7.916-.682-7.916s15.832-7.461,14.012-1.547c-.728,2.389-.49,5.745.064,8.9.162.919.349,1.82.546,2.675a62.733,62.733,0,0,0,1.756,6.173Z",
  transform: "translate(-70.402 -78.04)",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_544",
  "data-name": "Path 544",
  d: "M168.414,154.627s-18.107,2.184-16.378,0c.626-.79.8-3.13.764-5.8a11.4,11.4,0,0,1,6.273-.3c3.7-.737,6.069-.593,7.585-.076a62.735,62.735,0,0,0,1.756,6.173Z",
  transform: "translate(-70.402 -85.853)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_545",
  "data-name": "Path 545",
  d: "M118.855,186.75V186.6l31.959-.348,19.472-.182h.055l-.02.269.027-.269h.035v-.031l.249-2.448.095-.926.029-.289.025-.242,1.125-3.751,1.125-3.745.946-3.154,1.445-4.819a16.17,16.17,0,0,0-1.274-2.457c-.455-.546-.91-4.276-.91-4.276s-3.883-3.7-5.581-4.125c-.712-.182-2.116-.424-3.609-.728-.559-.113-1.132-.233-1.683-.364-.311-.071-.617-.146-.91-.22a16,16,0,0,1-1.683-.52,3.766,3.766,0,0,1-.819-.417c-1.338-.981-4.69-1.092-4.819-1.092h0a.077.077,0,0,1,0-.013v-.016a1.869,1.869,0,0,0,0-.229,1.463,1.463,0,0,0-.016-.255.229.229,0,0,0-.013-.091c-.009-.066-.02-.135-.036-.207a.907.907,0,0,0-.022-.1,3.132,3.132,0,0,0-.227-.635c-.013-.029-.029-.06-.044-.089a3.322,3.322,0,0,0-.309-.479c-.024-.031-.049-.064-.076-.095a3.562,3.562,0,0,0-.5-.48c-.049-.038-.1-.078-.153-.115a.85.85,0,0,0-.093-.066l-.162-.106-.151-.087c-.133-.073-.273-.144-.426-.211-.047-.022-.1-.042-.149-.062l-.2-.076h-.011l-.136-.055c-.1-.035-.209-.065-.32-.1l-.169-.044-.182-.042-.182-.038c-.182-.036-.377-.069-.581-.095l-.207-.025-.213-.022-.22-.018-.313-.018-.364-.013a22.693,22.693,0,0,0-4.777.508,13.151,13.151,0,0,0-3.321-.306h-.158l-.182.011h-.116l-.235.022a1.749,1.749,0,0,0-.237.027c-.078.011-.16.02-.238.033l-.12.02c-.118.02-.238.042-.364.067q-.06.011-.12.027c-.158.035-.317.076-.473.124-.078.022-.156.047-.235.075-.04.011-.078.025-.116.04l-.116.042-.115.046-.136.055c-.069.029-.136.06-.2.093-.038.016-.076.035-.113.055s-.075.036-.109.056a5.05,5.05,0,0,0-1.13.8l-.093.089-.091.093c-.031.031-.06.064-.089.1a4.34,4.34,0,0,0-.331.409c-.029.038-.056.076-.084.116a4.858,4.858,0,0,0-.313.531c-.024.044-.046.089-.067.133a5.952,5.952,0,0,0-.364.955q-.051.182-.093.364s-3.853,1.7-7.048,2.93c-.85.328-1.651.624-2.32.848l-.546.182a4.858,4.858,0,0,1-1.137.262,3.579,3.579,0,0,0-.546.051c-1.469.238-3.985,1.274-4.26,2.313a.671.671,0,0,0-.018.255s0,.013,0,.02c.182,1.274-1.092,1.092-1.092,1.092s-.455,3.367-1.092,4.276a7.163,7.163,0,0,0-.815,3.219h0a3.569,3.569,0,0,0,.08,1.025v.025a4.492,4.492,0,0,1-.4,1.763c-.322.937-.792,2.1-1.243,3.2a37.288,37.288,0,0,0-1.361,3.5c-.016.147-.064.411-.129.752-.266,1.387-.855,4.027-1.146,5.1-.217.8-.531,1.889-.748,2.639a.256.256,0,0,1-.018.064l8.158-.08v.153h.025Z",
  transform: "translate(-55.212 -85.988)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_546",
  "data-name": "Path 546",
  d: "M128.335,175.046s10.373,5.368,14.1,4.731Z",
  transform: "translate(-61.715 -95.773)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_547",
  "data-name": "Path 547",
  d: "M161.755,171.588s10.1,3.276,13.466,3.731S161.755,171.588,161.755,171.588Z",
  transform: "translate(-74.026 -94.506)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_548",
  "data-name": "Path 548",
  d: "M168.114,152.792c-5.277.972-15.213.763-19.508.615,1.574-5.641,9.25-3.723,9.25-3.723C167.357,147.787,168.085,151.722,168.114,152.792Z",
  transform: "translate(-69.182 -86.281)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_549",
  "data-name": "Path 549",
  d: "M168.114,152.215c-5.277.972-15.213.762-19.508.615,1.574-5.641,9.25-3.723,9.25-3.723C167.357,147.211,168.085,151.145,168.114,152.215Z",
  transform: "translate(-69.182 -86.069)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_550",
  "data-name": "Path 550",
  d: "M223.842,193.606s6.216-.955,6.338,1.774-3.17,4.637-3.17,4.637Z",
  transform: "translate(-96.897 -102.511)",
  fill: "#fbbebe"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_551",
  "data-name": "Path 551",
  d: "M166.173,137.954a8.566,8.566,0,0,1-.819.317,29.248,29.248,0,0,1-6.005,1.607,9.812,9.812,0,0,1-6.034-1,5.239,5.239,0,0,1-.546-.355c-.2-4-.682-7.916-.682-7.916s15.832-7.461,14.012-1.547C165.374,131.449,165.62,134.8,166.173,137.954Z",
  transform: "translate(-70.464 -78.052)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_552",
  "data-name": "Path 552",
  d: "M154.452,103.735a1.723,1.723,0,0,1-1.514-.318l.379.526a1.541,1.541,0,0,1-1.234-.409,6.2,6.2,0,0,0,.058,1.41,2.642,2.642,0,0,1-1.74-.546.8.8,0,0,0,.48.784,2.61,2.61,0,0,0-2.839,1.949l.95.087a3.361,3.361,0,0,0-1.9,1.159,1.472,1.472,0,0,0-.386,1.274c.127.444.742.728,1.077.411a5.084,5.084,0,0,0-1.11,4.147,2.634,2.634,0,0,1,.084.957,8.122,8.122,0,0,1-.344.853,2.7,2.7,0,0,0,.153,1.638l.853,2.806c.309,1.014.617,2.029,1.021,3.01a14.935,14.935,0,0,1,.728,1.913A8.81,8.81,0,0,0,149.9,128a3.627,3.627,0,0,0,1.307,1.152,9.817,9.817,0,0,0,6.034,1,29.229,29.229,0,0,0,6-1.607,5.642,5.642,0,0,0,1.245-.546c1.356-.888,1.658-2.7,1.911-4.3a24.437,24.437,0,0,1,1.327-5.241,7.072,7.072,0,0,0,.823-3.083c-.111-1.421-1.236-2.573-1.514-3.971a3.457,3.457,0,0,1,.013-1.414,3.214,3.214,0,0,0,.144-.855,2.182,2.182,0,0,0-.963-1.414q-1.469-1.227-3.032-2.318c-.053-.364.442-.52.666-.808.317-.406-.011-1.05-.491-1.239a2.515,2.515,0,0,0-1.52.06,1.2,1.2,0,0,0-2.1-.93,1.856,1.856,0,0,0-1.532-1.106c-1.207-.095-1.23.828-2,1.336s-1.409-.162-2-.65A1.689,1.689,0,0,0,154.452,103.735Z",
  transform: "translate(-68.346 -68.715)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_553",
  "data-name": "Path 553",
  d: "M220.811,192.289s-.162.386-.46.944a12.556,12.556,0,0,1-1.638,2.4l-.049.053h-.295l-10.507.1h-.251l-.031-.036-2.038-2.418-.768-.912-.031-.038-.066-.076-.036-.044-.047-.056-1.494-1.772.546-2.275.93-3.832.024-.093.182-.728.129-.546.433-1.78,1.485-6.124,2.639,1.365,2.782,4.913,1.494,2.639h.819c.155,0,.51.3.866.642.127.122.255.251.364.364.324.335.581.622.581.622s1.327.029,1.683,1.074a1.274,1.274,0,0,1,.046.155,7.335,7.335,0,0,0,.46,1.194c.235.511.53,1.092.828,1.672.555,1.065,1.119,2.078,1.327,2.446l.025.045Z",
  transform: "translate(-89.255 -95.735)",
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_554",
  "data-name": "Path 554",
  d: "M175.89,188.1l-.018.26v.018l-.031.419-.242,3.368-.293,4.058-.084,1.143-.182,2.446v.031l-19.472.182-31.953.346v.153h-.025v-.2l.082-2.613.157-5.106.135-4.329.013-.431a1.916,1.916,0,0,1,2.078-1.851c.859.073,1.974.162,3.308.257l.546.04a294.691,294.691,0,0,0,36.3.364c.3-.016.606-.035.91-.056,2.227-.14,4.453-.32,6.657-.546a1.916,1.916,0,0,1,2.111,2.044Z",
  transform: "translate(-59.967 -99.763)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_555",
  "data-name": "Path 555",
  d: "M123.621,200.952V200.8l31.959-.348,19.472-.182h.055v-.031l.182-2.446.078-1.092.3-4.115.235-3.257v-.08a1.932,1.932,0,0,0-.02-.449.055.055,0,0,0,0-.018,1.891,1.891,0,0,0-.364-.844,1.918,1.918,0,0,0-1.714-.728c-2.2.226-4.429.406-6.657.546-.3.022-.608.04-.91.056a298.393,298.393,0,0,1-36.3-.364l-.546-.04c-1.334-.095-2.449-.182-3.308-.257a1.918,1.918,0,0,0-2.045,1.552,2,2,0,0,0-.033.3l-.124,4.033-.169,5.108-.08,2.613v.2Z",
  transform: "translate(-59.978 -100.191)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_556",
  "data-name": "Path 556",
  d: "M175.959,190.6l-.224,2.79-.333,4.158-.084,1.041-.182,2.331-.011.116v.031h0l-.027.269.02-.269h-.053l-19.472.182-31.964.346v-.051l.089-2.613.182-5.106.116-3.394a1.158,1.158,0,0,1,.557-.955,1.137,1.137,0,0,1,.688-.164c.382.031.852.067,1.4.107.89.066,1.987.142,3.265.222,2.366.149,5.334.309,8.735.44a284.378,284.378,0,0,0,34.372-.577c.546-.047,1.11-.1,1.661-.153a1.139,1.139,0,0,1,.633.12.939.939,0,0,1,.157.1,1.117,1.117,0,0,1,.364.448.652.652,0,0,1,.045.111A1.143,1.143,0,0,1,175.959,190.6Z",
  transform: "translate(-59.982 -100.988)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_557",
  "data-name": "Path 557",
  d: "M103.737,195.3v.581a1.116,1.116,0,0,1-.637,1.008l-7.3.14a1.114,1.114,0,0,1-.65-1.014v-.546Z",
  transform: "translate(-49.492 -103.195)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_558",
  "data-name": "Path 558",
  d: "M80.484,147.62l-9.508.182v-1.578l9.508-.182Z",
  transform: "translate(-26.147 -53.584)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_559",
  "data-name": "Path 559",
  d: "M80.484,147.62l-9.508.182v-1.578l9.508-.182Z",
  transform: "translate(-26.147 -53.584)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_560",
  "data-name": "Path 560",
  d: "M81.06,147.62l-9.508.182v-1.578l9.508-.182Z",
  transform: "translate(-26.359 -53.584)",
  fill: "#3f3d56"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_47",
  "data-name": "Group 47",
  transform: "translate(78.064 33.635)",
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_561",
  "data-name": "Path 561",
  d: "M159.091,103.708a1.774,1.774,0,0,1-.344-.79,1.727,1.727,0,0,0,.076.837A1.638,1.638,0,0,0,159.091,103.708Z",
  transform: "translate(-150.974 -102.918)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_562",
  "data-name": "Path 562",
  d: "M155.605,105.689a6.4,6.4,0,0,1-.067-.673v.675Z",
  transform: "translate(-149.799 -103.69)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_563",
  "data-name": "Path 563",
  d: "M179.118,114.8a3.333,3.333,0,0,1,.065-.482,3.276,3.276,0,0,0,.146-.853,1.125,1.125,0,0,0-.029-.193c-.031.167-.08.335-.116.5A3.483,3.483,0,0,0,179.118,114.8Z",
  transform: "translate(-158.481 -106.733)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_564",
  "data-name": "Path 564",
  d: "M173.13,106.255l.2.144a3.587,3.587,0,0,0,.468-.4.668.668,0,0,0,.069-.662.545.545,0,0,1-.069.116C173.573,105.736,173.078,105.895,173.13,106.255Z",
  transform: "translate(-156.278 -103.807)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_565",
  "data-name": "Path 565",
  d: "M149.366,109.565a2.242,2.242,0,0,0-.158.415,3.3,3.3,0,0,1,.91-.344Z",
  transform: "translate(-147.467 -105.366)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_566",
  "data-name": "Path 566",
  d: "M153.231,106.3a2.7,2.7,0,0,1-.342-.224.773.773,0,0,0,.016.215,2.159,2.159,0,0,1,.326.009Z",
  transform: "translate(-148.823 -104.081)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_567",
  "data-name": "Path 567",
  d: "M168.653,123.405a9.372,9.372,0,0,1-.819,2.57,24.425,24.425,0,0,0-1.327,5.243c-.253,1.6-.546,3.416-1.911,4.3a5.458,5.458,0,0,1-1.243.546,29.132,29.132,0,0,1-6.005,1.607,9.812,9.812,0,0,1-6.034-1,3.64,3.64,0,0,1-1.307-1.152,9.033,9.033,0,0,1-.728-2.615,14.962,14.962,0,0,0-.728-1.914c-.4-.979-.712-2-1.019-3.008q-.428-1.4-.853-2.808a5.243,5.243,0,0,1-.207-.864,3.262,3.262,0,0,0,.207,1.41q.426,1.407.853,2.808c.308,1.014.617,2.029,1.019,3.008a14.961,14.961,0,0,1,.728,1.914,8.809,8.809,0,0,0,.728,2.615,3.64,3.64,0,0,0,1.307,1.152,9.818,9.818,0,0,0,6.034,1,29.349,29.349,0,0,0,6.005-1.607,5.459,5.459,0,0,0,1.243-.546c1.356-.886,1.658-2.7,1.911-4.3a24.424,24.424,0,0,1,1.327-5.243,7.059,7.059,0,0,0,.823-3.083C168.656,123.427,168.653,123.416,168.653,123.405Z",
  transform: "translate(-146.452 -110.465)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_568",
  "data-name": "Path 568",
  d: "M147.022,121.369v-.02a2.548,2.548,0,0,0-.084-.955,4.843,4.843,0,0,1-.071-.6,4.978,4.978,0,0,0,.071,1.15C146.967,121.082,147,121.225,147.022,121.369Z",
  transform: "translate(-146.602 -109.133)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_569",
  "data-name": "Path 569",
  d: "M147.623,114.616a5.045,5.045,0,0,1,.475-.668c-.333.318-.948.035-1.077-.408a1.061,1.061,0,0,0,0,.546A.8.8,0,0,0,147.623,114.616Z",
  transform: "translate(-146.649 -106.831)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_570",
  "data-name": "Path 570",
  d: "M219.8,189.163a7.907,7.907,0,0,1,0,3.913C219.227,194.9,219.8,189.163,219.8,189.163Z",
  transform: "translate(-95.314 -100.934)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_571",
  "data-name": "Path 571",
  d: "M223.559,192.542s.242,2.657-.3,3.128S223.559,192.542,223.559,192.542Z",
  transform: "translate(-96.613 -102.179)",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_4",
  "data-name": "Line 4",
  y1: 0.182,
  x2: 18.491,
  transform: "translate(36.21 62.34)",
  fill: "none",
  stroke: "#e30613",
  strokeMiterlimit: 10,
  strokeWidth: 0.576
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_5",
  "data-name": "Line 5",
  y1: 0.18,
  x2: 18.491,
  transform: "translate(36.21 64.616)",
  fill: "none",
  stroke: "#e30613",
  strokeMiterlimit: 10,
  strokeWidth: 0.576
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_6",
  "data-name": "Line 6",
  y1: 0.182,
  x2: 18.491,
  transform: "translate(36.21 66.891)",
  fill: "none",
  stroke: "#e30613",
  strokeMiterlimit: 10,
  strokeWidth: 0.576
})));

var SvgSixMonitorsGuy = function SvgSixMonitorsGuy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_109",
    "data-name": "Group 109",
    width: 190,
    height: 110,
    viewBox: "0 0 190 110",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSixMonitorsGuy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SixMonitorsGuy.5758889f.svg";
export { ForwardRef as ReactComponent };